var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 68"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#2895EB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 5,
    cy: 7,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 13,
    cy: 7,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 9,
    cy: 13,
    r: 3,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaces);
export default __webpack_public_path__ + "static/media/workspaces.ffbc3a0e8d362fb054d7b9814ea3e534.svg";
export { ForwardRef as ReactComponent };